// extracted by mini-css-extract-plugin
export var select = "_ow-0";